<template>
    <div class="video-player d-flex justify-content-center" id="conteudoVideo">
        <video id="videoPlayer" ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered" ></video>
    </div>
</template>

<script>
    import videojs from 'video.js';
    import 'video.js/dist/video-js.css'

    //videoOptions: {
    //    autoplay: true,
    //        controls: true,
    //            sources: [
    //                {
    //                    src:
    //                        "/path/to/video.mp4",
    //                    type: "video/mp4"
    //                }
    //            ]
    //}

    export default {
        name: 'VideoPlayer',
        props: {
            options: {
                type: Object,
                default() {
                    return {};
                }
            },
            atualizarTempo: {
                type: Function,
                required: true,
            },
            avisoFimVideo: {
                type: Function,
                required: true,
            },
            currentTime: {
                type: Number,
                default: 0,
            },
        },
        data: function () {
            return {
                player: null,
                timeElapsedFormat: null,
                timeElapsed: null,

                timerAtualizacao: null,
                htmlVideo: '<video ref="videoPlayer" id="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered" ></video>',
            }
        },
        methods: {
            formatTime(timeInSeconds) {
                return new Date(timeInSeconds * 1000).toISOString().substr(11, 8);
            },

            registraTempo() {
                let $this = this;
                // se tempo atual diferente da ultima atualizacao
                if ($this.timeElapsed != $this.player.currentTime()) {
                    $this.timeElapsed = $this.player.currentTime();
                    $this.atualizarTempo($this.timeElapsedFormat);
                }
            },

            load() {
                let $this = this;
                $this.clear();
                this.player = videojs(document.getElementById('videoPlayer'), this.options, function () { })

                this.player.src(this.options.sources[0]);
                // trigger quando termina video
                this.player.on("ended", function () {
                    $this.registraTempo();
                    $this.avisoFimVideo();
                });
                // trigger quando avanca video
                this.player.on("seeked", function () {
                    $this.registraTempo();
                });

                // trigger quando video atualiza o tempo
                this.player.on("timeupdate", function () {
                    $this.timeElapsedFormat = $this.formatTime(Math.floor($this.player.currentTime()));
                });

                this.player.on("loadedmetadata", function () {

                    // ATUALIZA��O DO TEMPO ASSISTIDO
                    $this.timerAtualizacao = setInterval(function () {
                        $this.registraTempo();
                    }, 10000);

                    // SETA TEMPO VIDEO INICIAL
                    if ($this.currentTime > 0) {
                        $this.player.currentTime($this.currentTime);
                    }
                });
            },

            clear() {   
                // destroy player antigo
                if (this.player) {
                    this.player.dispose()
                }
                // incluiu tag video nova
                document.getElementById('conteudoVideo').innerHTML = this.htmlVideo;

                if (this.timerAtualizacao != null) {
                    clearInterval(this.timerAtualizacao);
                }
            },
        },
        mounted() {
            this.load();
        },
        beforeDestroy() {
            this.clear();
        },
        watch: {
            options: {
                handler(newValue, oldValue) {
                    if (newValue.sources[0].src != oldValue.sources[0].src) {
                        this.load();
                    }
                },
                deep: true
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
</style>

